export default {
      id: "i-profile-user-new-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/sprite.svg#i-profile-user-new",
      toString: function () {
        return this.url;
      }
    }